<template>
	<div class="page container">
		<error />
	</div>
</template>

<script>

	import Error from '@/components/ui/Error';

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Error'
		},
		components: {
			Error
		}
	};

</script>

<style lang="scss" scoped>
	[data-route] {
		padding-top:rem(48);
	}
</style>
